import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import {
  MetaCard,
  Conversation,
} from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'sticky-steps'

/**
 * This is the component description.
 */
const StickySteps = ({
  id,
  className:userClassName,
  style,
  title,
  items,
}) => (
  <MetaCard
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
      'span-grid grid dense',
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    <h2
      className="span-8 md-start-2 md-span-6 title"
    >
      {title}
    </h2>
    {
      items.map((item) => (
        <div
          className="grid span-grid steps"
        >
          <div className="step span-8 md-start-2 md-span-6">
            <div className="step-text s1">
              <h3>
                {item.title}
              </h3>
              {item.description}
            </div>
          </div>
          <Conversation className="hide-on-mobile md-start-9 md-span-5">
            {
              item.conversation.map((message) => (
                <Conversation.Message
                  {...message}
                />
              ))
            }
          </Conversation>
        </div>
      ))
    }
  </MetaCard>
)

StickySteps.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The steps to iterate
   */
  items:PropTypes.arrayOf(PropTypes.shape({
    title      :PropTypes.string,
    description:PropTypes.node,
    image      :PropTypes.string,
  })).isRequired,

  /**
   * The title to pass to the component
   */
  title:PropTypes.string,
}

StickySteps.defaultProps = {
  title:'Maximize your impact with Pareto in 3 simple steps',
}

export default StickySteps
